'use client';
import { jsx, Fragment } from 'react/jsx-runtime';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { TableGroupRow } from './TableGroupRow.js';
import { TableLoader } from './TableLoader.js';
import { useTable } from './TableProvider.js';
import { TableRow } from './TableRow.js';

const TBody = styled.tbody.withConfig({
  componentId: "sc-1ee8vk2-0"
})(["position:relative;color:", ";"], ({
  theme
}) => theme.components.table.headerFontColor);
const WithSortableContext = ({
  children,
  rows
}) => {
  const {
    isDraggable
  } = useTable();
  if (!isDraggable) return jsx(Fragment, {
    children: children
  });
  return jsx(SortableContext, {
    items: rows,
    strategy: verticalListSortingStrategy,
    children: children
  });
};
const TableBody = /*#__PURE__*/withTitan(() => {
  const {
    instance,
    isLoading
  } = useTable();
  const {
    getRowModel
  } = instance;
  if (isLoading) {
    return jsx(TBody, {
      "data-test-id": "tableLoader",
      children: jsx(TableLoader, {})
    });
  }
  const rows = getRowModel().rows;
  const groupedRowIndexes = rows.reduce((acc, row, index) => {
    if (row.getIsGrouped()) acc.push(index);
    return acc;
  }, []);
  return jsx(TBody, {
    "data-test-id": "tableBody",
    children: jsx(WithSortableContext, {
      rows: rows,
      children: rows.map((row, index) => {
        if (row.getIsGrouped()) {
          return jsx(TableGroupRow, {
            row: row
          }, row.id);
        }
        const nextParentIndex = groupedRowIndexes.findIndex(i => i > index);
        const parentGroupIndex = groupedRowIndexes[nextParentIndex - 1];
        const indexInGroup = parentGroupIndex ? index - parentGroupIndex - 1 : index;
        return jsx(TableRow, {
          indexInGroup: indexInGroup,
          row: row
        }, row.id);
      })
    })
  });
}, {
  name: 'TableBody'
});

export { TableBody };
//# sourceMappingURL=TableBody.js.map
